export function injectAPICache(apiCache, axiosInstance) {
  const originalGet = axiosInstance.get.bind(axiosInstance);

  function getWithCache(url) {
    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const cached = apiCache.get(url, config.params);

    if (cached !== null) {
      console.log('[API] cache hit', url, config.params);
      return Promise.resolve({
        data: cached,
        status: 200,
        statusText: 'OK',
        //TODO: find a better type here
        //@ts-expect-error
        headers: config.headers,
        config
      });
    }

    return originalGet(url, config).then(r => {
      apiCache.set(url, config.params, r.data);
      return r;
    });
  }

  return { ...axiosInstance,
    get: getWithCache
  };
}